/**
 * Branding utility to check if user logged in via Xtravex login
 * and return appropriate branding text/logo
 */

export const BrandingUtils = {
    /**
     * Check if user logged in via Xtravex login
     * @returns {boolean}
     */
    isXtravexLogin: () => {
        const loginPath = localStorage.getItem('loginPath');
        return loginPath === '/xtravex-login';
    },

    /**
     * Get branding name based on login source
     * @returns {string} 'Xtravex' or 'Eventegration'
     */
    getBrandingName: () => {
        return BrandingUtils.isXtravexLogin() ? 'Xtravex' : 'Eventegration';
    },

    /**
     * Get branding logo URL
     * @param {string} eventId - Optional event ID for logo
     * @returns {string} Logo URL
     */
    getBrandingLogo: (eventId = '1745879876') => {
        if (BrandingUtils.isXtravexLogin()) {
            return `https://api-admin.eventegration.com/public/logo/${eventId}.png`;
        }
        return null; // Use default Eventegration logo
    },

    /**
     * Get "Powered by" text
     * @returns {string}
     */
    getPoweredByText: () => {
        return BrandingUtils.isXtravexLogin() ? 'Xtravex' : 'Eventegration';
    },

    /**
     * Get "Powered by" link
     * @returns {string}
     */
    getPoweredByLink: () => {
        return BrandingUtils.isXtravexLogin() ? 'https://xtravex.com' : 'https://eventegration.com';
    },
};
